
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 75.595 66.15","height":"250.017","width":"285.713"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-67.202 -35.868)"}},[_c('rect',{attrs:{"width":"75.595","height":"13.607","x":"67.203","y":"35.868","ry":"2.929"}}),_c('rect',{attrs:{"width":"75.595","height":"13.607","x":"67.203","y":"62.139","ry":"2.929"}}),_c('rect',{attrs:{"width":"75.595","height":"13.607","x":"67.202","y":"88.411","ry":"2.929"}})])])
          )
        }
      }
    